module.exports = __webpack_public_path__ + "img/tahdir.d7d20d6f.png";